<template>
    <div class="returnVisit">
        <div>本产品{{ getReturnStatus() }}</div>

        <div class="stepText" v-if="guideData.receiptStatus == '0'">
            <div class="title">回执操作流程：</div>
            <div v-if="guideData.receiptDesc"><span v-for="(v, index) in guideData.receiptDesc.split('\n')" :key="index">{{ v }}<br /></span></div>
            <div v-else>暂无内容</div>
        </div>
        <div class="stepText" v-if="guideData.revisitStatus == '0'">
            <div class="title">回访操作流程：</div>
            <div v-if="guideData.revisitDesc"><span v-for="(v, index) in guideData.revisitDesc.split('\n')" :key="index">{{ v }}<br /></span></div>
            <div v-else>暂无内容</div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            guideData: {}
        };
    },
    created() {
        this.getGuideData();
    },
    methods: {
        getReturnStatus() {
            let receiptStatus, revisitStatus;
            if (this.guideData.receiptStatus == '0') {
                receiptStatus = '需要回执';
            } else if (this.guideData.receiptStatus == '-1') {
                receiptStatus = '无需回执';
            } else if (this.guideData.receiptStatus == '1') {
                receiptStatus = '默认回执成功';
            } else {
                receiptStatus = '';
            }
            if (this.guideData.revisitStatus == '0') {
                revisitStatus = '需要回访';
            } else if (this.guideData.revisitStatus == '-1') {
                revisitStatus = '无需回访';
            } else if (this.guideData.revisitStatus == '1') {
                revisitStatus = '回访成功';
            } else {
                revisitStatus = '';
            }
            if (receiptStatus && revisitStatus) {
                return receiptStatus + '，' + revisitStatus;
            }
        },
        getGuideData() {
            this.productCode = this.$route.query.productCode;
            this.$http({
                url: '/api/productBase/detail',
                type: 'GET',
                data: {
                  productCode: this.productCode
                }
            }).then(res => {
                this.guideData = res.data;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.returnVisit {
    background: #fff;
    min-height: 100vh;
    padding: 40px;
    font-weight: 400;
    font-size: 32px;
    color: #333333;
    line-height: 50px;
    .stepText{
      margin-top: 40px;
      .title{
        font-weight: 600;
        font-size: 34px;
        color: #333333;
        line-height: 50px;
        margin-bottom: 20px;
      }
    }
}

</style>
